import { Link, useLocation } from "react-router-dom";
import "./SecondCategory.css";
import { CATALOG_MAIN_LINK, IMG_PLACEHOLDER_PRODUCT } from "../../../../assets/utils/constants";
import mainApi from "../../../../assets/api/MainApi";
import cat1 from '../../../../assets/images/cat1.jpeg'
import cat2 from '../../../../assets/images/cat2.jpeg'
import cat3 from '../../../../assets/images/cat3.jpeg'
import cat4 from '../../../../assets/images/cat4.jpeg'
import cat5 from '../../../../assets/images/cat5.jpeg'
import cat6 from '../../../../assets/images/cat6.jpeg'
function SecondCategory() {

    const SECOND_CATEGORY = [
        {
            name: 'Стены потолки',
            link: 'dlja-vnutrennih-rab-qqlk/cteny-i-potolki--gr-wtvf',
            img: cat1
        },
        {
            name: `Деревянные</br> поверхности`,
            link: 'dlja-vnutrennih-rab-qqlk/derevjannye-poverhn-0bbe',
            img: cat2
        },
        {
            name: `Помещения</br>
            с повышенной</br>
            влажностью`,
            link: 'dlja-vnutrennih-rab-qqlk/okraska-pomeschenij-wd6k',
            img: cat3
        },
        {
            name: `Универсальные</br>
            материалы`,
            link: 'materialy-universal-xw4q',
            img: cat6
        },
        {
            name: `Уличные</br>
            деревянные </br>
            поверхности`,
            link: 'dlja-vneshnih-rabot-iekx/derevjannye-poverhn-8qla',
            img: cat4
        },
        {
            name: `Минеральные</br>
            фасады`,
            link: 'dlja-vneshnih-rabot-iekx/mineralnye-fasady-n7dz',
            img: cat5
        },
    ]


    return (
        <div className={`second-category`} >
            {SECOND_CATEGORY.map((item, i) => {
                return (
                    <Link className="custom-categories__item"
                        to={`/${CATALOG_MAIN_LINK}/${item.link}`}
                        key={item.link}
                    >
                        <img
                            className="custom-categories__img"
                            src={item.img ? item.img : IMG_PLACEHOLDER_PRODUCT}
                            alt={item.name}
                        />
                        <p className="second-category__title" dangerouslySetInnerHTML={{ __html: item.name }} />
                    </Link>
                )
            })}
        </div >
    );
}

export default SecondCategory